<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="icon.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Ikona
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control"
                        ref="highlightedImage"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <router-link
            exact
            :to="{ name: 'CleaningNoteIcons' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
    <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
      <i class="bx bx-trash text-4 me-2"></i> Delete Category
    </a>
  </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'EditCleaningPlanNoteIcon',
  mixins: [translations],
  computed: {
    icon() {
      return this.$store.getters.getCleaningPlanNoteIcon;
    },
  },
  methods: {
    submitForm() {
      const { icon } = this;

      api
        .updateCleaningPlanNoteIcon(icon)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CleaningNoteIcons' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    handlePhotoUpload() {
      const file = this.$refs.highlightedImage.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.icon.icon = e.target.result.split(',')[1];
      };
    },
  },
  mounted() {
    this.$store.dispatch('getCleaningPlanNoteIcon', this.$route.params.id);
  },
};
</script>
